import { nullSafeGetOrElse } from './DataAccessUtils';

export const getFixedFloatStringOrZero = (value) =>
	value ? `${parseFloat(value).toFixed(2)}` : '0';

export const getFixedFloatSum = (value1, value2) =>
	(parseFloat(value1) + parseFloat(value2)).toFixed(2);

export const recalculateInvoiceTotalFields = (form) => {
	const subtotals = form.getFieldsValue([
		'laborTotalBeforeTax',
		'partsTotalBeforeTax',
		'equipmentTotalBeforeTax',
		'freightTotalBeforeTax',
		'travelTotalBeforeTax',
		'miscTotalBeforeTax',
		'invoiceTax',
	]);
	const invoiceTotalBeforeTax = (
		parseFloat(nullSafeGetOrElse('laborTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('partsTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('equipmentTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('freightTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('travelTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('miscTotalBeforeTax', subtotals, 0))
	).toFixed(2);

	const invoiceTotalAfterTax = (
		parseFloat(invoiceTotalBeforeTax) + parseFloat(nullSafeGetOrElse('invoiceTax', subtotals, 0))
	).toFixed(2);

	const materialTotalBeforeTax = (
		parseFloat(nullSafeGetOrElse('partsTotalBeforeTax', subtotals, 0)) +
		parseFloat(nullSafeGetOrElse('equipmentTotalBeforeTax', subtotals, 0))
	).toFixed(2);

	form.setFieldsValue({
		invoiceTotalBeforeTax,
		invoiceTotalAfterTax,
		materialTotalBeforeTax,
	});
};

export const getInvoiceEntityCommonValues = (values, formData, scope, currentUser) => {
	const laborItems = values.laborKeys.map((laborKey) => {
		let laborItem = {
			roleType: values[`labor-${laborKey}-roleType`],
			numberOfTech: parseInt(values[`labor-${laborKey}-numberOfTech`], 10),
			seconds: parseFloat(values[`labor-${laborKey}-minutes`]) * 60,
			hourlyRate: values[`labor-${laborKey}-hourlyRate`],
			amount: values[`labor-${laborKey}-amount`],
		};
		return laborItem;
	});

	const partsItems = values.partsKeys.map((partsKey) => {
		let partAmt = values[`parts-${partsKey}-amount`];
		let partItem = {
			description: values[`parts-${partsKey}-description`],
			partId: values[`parts-${partsKey}-partId`],
			partNumber:
				values[`parts-${partsKey}-partNumber`] !== undefined
					? values[`parts-${partsKey}-partNumber`]
					: values[`parts-${partsKey}-partId`],
			unitType: values[`parts-${partsKey}-unitType`],
			quantity: values[`parts-${partsKey}-quantity`]
				? `${values[`parts-${partsKey}-quantity`]}`
				: '',
			unitPrice: values[`parts-${partsKey}-unitPrice`]
				? `${values[`parts-${partsKey}-unitPrice`]}`
				: '',
			amount: `${partAmt}`,
		};
		return partItem;
	});

	const equipmentItems = values.equipmentKeys.map((equipmentKey) => {
		let equipmentAmt = values[`equipment-${equipmentKey}-amount`];
		let equipmentItem = {
			description: values[`equipment-${equipmentKey}-description`],
			equipmentId: values[`equipment-${equipmentKey}-equipmentId`],
			equipmentNumber:
				values[`equipment-${equipmentKey}-equipmentNumber`] !== undefined
					? values[`equipment-${equipmentKey}-equipmentNumber`]
					: values[`equipment-${equipmentKey}-equipmentId`],
			quantity: '1',
			unitType: 'each',
			unitPrice: values[`equipment-${equipmentKey}-unitPrice`]
				? `${values[`equipment-${equipmentKey}-unitPrice`]}`
				: undefined,
			amount: `${equipmentAmt}`,
		};
		return equipmentItem;
	});

	const miscItems = values.miscKeys.map((miscKey) => {
		let miscAmt = values[`misc-${miscKey}-amount`];
		let miscItem = {
			description: values[`misc-${miscKey}-description`],
			miscId: values[`misc-${miscKey}-miscId`],
			unitPrice: values[`misc-${miscKey}-unitPrice`]
				? `${values[`misc-${miscKey}-unitPrice`]}`
				: undefined,
			amount: `${miscAmt}`,
		};
		return miscItem;
	});

	const materialLineItems = partsItems.concat(equipmentItems);

	const taxLineItems = values.taxKeys.map((taxKey) => {
		return {
			taxType: `${values[`tax-${taxKey}-taxType`]}`,
			amount: `${values[`tax-${taxKey}-amount`]}`,
		};
	});

	return {
		id: values.id,
		scope,
		externalWorkOrderId: values.externalWorkOrderId,
		invoiceNumber: values.invoiceNumber,
		paymentTerms: values.paymentTerms,
		dueDate: values.dueDate,
		dateOfInvoice: values.dateOfInvoice,
		invoiceTaxRate: values.invoiceTaxRate,
		invoiceTax: getFixedFloatStringOrZero(values.invoiceTax),
		invoiceTotalBeforeTax: getFixedFloatStringOrZero(values.invoiceTotalBeforeTax),
		invoiceTotalAfterTax: getFixedFloatStringOrZero(values.invoiceTotalAfterTax),
		laborTotalBeforeTax: getFixedFloatStringOrZero(values.laborTotalBeforeTax),
		laborLineItems: laborItems || [],
		taxLineItems: taxLineItems || [],
		materialTotalBeforeTax: getFixedFloatStringOrZero(values.materialTotalBeforeTax),
		materialLineItems: materialLineItems || [],
		freightTotalBeforeTax: getFixedFloatStringOrZero(values.freightTotalBeforeTax),
		travelTotalBeforeTax: getFixedFloatStringOrZero(values.travelTotalBeforeTax),
		miscLineItems: miscItems || [],
		miscTotalBeforeTax: getFixedFloatStringOrZero(values.miscTotalBeforeTax),
		workOrderId: parseInt(formData.workOrderId, 10),
		createdBy: currentUser.email,
		attachments: values.attachments,
	};
};
